<!-- Copyright (c) 2023 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div>
    {{ $t('governance.requestModal.subtitle', { modal: $t('common.cancel').toLowerCase() }) }}
  </div>
</template>

<script>

export default {
  name: 'CancelRequest',
};
</script>
